// AdminPanelRouted — thin wrapper that mounts AdminPanel under a role prefix.
//
// For each role-prefixed route (/super-admin/*, /admin/*, /employee/*), this
// component wraps the existing AdminPanel with:
//   - NavProvider     (URL ↔ active-state sync)
//   - RouteGuard      (kicks unauth'd / wrong-role users)
//
// The AdminPanel itself reads the active state via useNav() (see INSTALL.md
// for the minimal patch needed to AdminPanel.jsx).

import AdminPanel from '../../AdminShell';
import RouteGuard from './RouteGuard';
import { NavProvider } from '../../lib/NavContext';

export default function AdminPanelRouted({ role, rolePrefix }) {
  return (
    <RouteGuard role={role}>
      <NavProvider rolePrefix={rolePrefix} defaultActive="dashboard">
        <AdminPanel />
      </NavProvider>
    </RouteGuard>
  );
}
